import { colors } from '@/theme/colors';

type SeatIconProps = {
  size?: { width: number; height: number };
  fill?: string;
};

export function SeatIcon({
  size = { width: 24, height: 24 },
  fill = colors.neutral10,
}: SeatIconProps) {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99023 6.74805C10.44 6.74805 11.6152 5.57279 11.6152 4.12305C11.6152 2.6733 10.44 1.49805 8.99023 1.49805C7.54049 1.49805 6.36523 2.6733 6.36523 4.12305C6.36523 5.57279 7.54049 6.74805 8.99023 6.74805Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.009 21.2372L14.486 18.0002H11.662C10.9927 18.0003 10.3425 17.7764 9.81505 17.3644C9.28756 16.9523 8.91302 16.3757 8.75104 15.7262L7.53504 10.8612C7.44723 10.4784 7.51309 10.0763 7.71849 9.74152C7.92389 9.40671 8.25242 9.16582 8.63351 9.07061C9.01459 8.9754 9.41782 9.03348 9.75654 9.23236C10.0953 9.43124 10.3425 9.75505 10.445 10.1342L11.66 15.0002H14.486C15.1996 14.9975 15.8906 15.2503 16.4339 15.7129C16.9772 16.1755 17.337 16.8173 17.448 17.5222L17.971 20.7612C18.0024 20.9557 17.9952 21.1545 17.9498 21.3462C17.9043 21.5379 17.8216 21.7187 17.7063 21.8784C17.5909 22.0382 17.4453 22.1736 17.2776 22.277C17.1099 22.3804 16.9235 22.4498 16.729 22.4812C16.5346 22.5126 16.3358 22.5054 16.1441 22.4599C15.9524 22.4145 15.7715 22.3318 15.6118 22.2164C15.4521 22.1011 15.3167 21.9555 15.2132 21.7878C15.1098 21.6201 15.0404 21.4337 15.009 21.2392V21.2372Z"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49023 11.248L6.20023 18.672C6.35238 19.334 6.72466 19.9248 7.25619 20.3477C7.78771 20.7705 8.44701 21.0006 9.12624 21H12.7402"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
